import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/banner2/12-2.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-e876574c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"banner\" data-v-e876574c><div class=\"banner-center\" data-v-e876574c><div class=\"textbox\" data-v-e876574c><div class=\"banner-text1\" data-v-e876574c>标准接口开发指南</div><div class=\"banner-text2\" data-v-e876574c>助力建设全国统一大市场，优化市场营商环境</div></div><div data-v-e876574c><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-e876574c></div></div></div>", 1)
const _hoisted_2 = { class: "list-main" }

import { reactive, toRefs, ref, onMounted } from 'vue'



import mytitle from '../components/title.vue'
import StandardCard from '../components/standard/standard-card'
import { ElMessage } from 'element-plus'

import { getRemoteBidEvaluationDocument,newEndpointDownload } from '../utils/axios/index.js'

// 接入指南

export default /*#__PURE__*/_defineComponent({
  __name: 'interfaceGuide',
  setup(__props) {

const guides = ref([
  { title: '远程异地评标技术标准<br>远程异地评标项目登记工具接入指南', type: 8, name: '远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南' },

  { title: '远程异地评标技术标准<br>场所工位预约工具接入指南', type: 9, name: '远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南' },

  { title: '远程异地评标技术标准<br>场地专家签到工作台接入指南', type: 10, name: '远程异地评标和评标专家库共享技术标准_场地专家签到工作台接入指南' },


  { title: '远程异地评标技术标准<br>场地专家评标登录接入指南', type: 11, name: '远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南' },

  { title: '远程异地评标技术标准<br>专家库共享抽取工具接入指南', type: 12, name: '远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南' },





])



// 预览 
const previewGuide = (item: any) => {
  // getRemoteBidEvaluationDocument({ documentType:item.type }).then(res => {
  //       window.open(res.data.documentUrl, '_blank');

  //   }).catch(res => {
  //       ElMessage.warning('功能开发中，敬请期待！')
  //   })
  if (item.type == '8') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '远程异地评标项目登记工具接入指南预览'])
    }
    if (item.type == '9') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '场所工位预约工具接入指南预览'])
    }
    if (item.type == '10') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '场地专家签到工作台接入指南预览'])
    }
    if (item.type == '11') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '场地专家评标登录工作台接入指南预览'])
    }
    if (item.type == '12') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '预览', '专家库共享抽取工具接入指南预览'])
    }
  window.open(item.name + '.pdf', '_blank');

}


// 下载 
const downloadGuide = (item: any) => {
    // let name2 = ''
    // getRemoteBidEvaluationDocument({ documentType: item.type }).then(res => {
    //     name2 = res.data.documentName
    //     let url = res.data.name
    //     newEndpointDownload({contentDisposition:'attachment',filePath:url}).then(res => {
    //         var blob = new Blob([res])
    //         let fname = name2 + '.pdf'; //下载文件的名字
    //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //             window.navigator.msSaveOrOpenBlob(blob, fname);
    //         } else {
    //             let objectUrl = URL.createObjectURL(blob);
    //             let link = document.createElement("a");
    //             link.href = objectUrl;
    //             link.setAttribute("download", fname);
    //             document.body.appendChild(link);
    //             link.click();
    //         }
    //     })


      
    // }).catch(res => {
    //     ElMessage.warning('功能开发中，敬请期待！')
    // })


    const a = document.createElement('a')
    a.href = item.name + '.pdf'
    a.download = item.name + '.pdf'
    a.click()



    if (item.type == '8') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '远程异地评标项目登记工具接入指南下载'])
    }
    if (item.type == '9') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '场所工位预约工具接入指南下载'])
    }
    if (item.type == '10') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '场地专家签到工作台接入指南下载'])
    }
    if (item.type == '11') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '场地专家评标登录工作台接入指南下载'])
    }
    if (item.type == '12') {
        window._czc.push(['_trackEvent', '标准接口开发指南', '下载', '专家库共享抽取工具接入指南下载'])
    }
  



}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("section", null, [
        _createVNode(mytitle, { title: "接入指南" }),
        _createElementVNode("main", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guides.value, (item, index) => {
            return (_openBlock(), _createBlock(_unref(StandardCard), {
              key: index,
              title: item.title,
              onPreview: ($event: any) => (previewGuide(item)),
              onDownload: ($event: any) => (downloadGuide(item))
            }, null, 8, ["title", "onPreview", "onDownload"]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})